import { Col, Row, Select } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { LoanApplicationMerchantSnapshotBusinessInfo } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationMerchantSnapshotBusinessInfo';
import { LoanApplicationMerchantSnapshotGeneralInfo } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationMerchantSnapshotGeneralInfo';
import { LoanApplicationMerchantSnapshotSales } from 'src/pages/LoanApplicationDetailsPage/components/LoanApplicationMerchantSnapshotSales';
import { LoanApplicationsStore } from 'src/stores/LoanApplicationsStore/LoanApplicationsStore';
import { DateHelper } from 'src/utils/DateHelper';
import styled from 'styled-components';

export const LoanApplicationMerchantSnapshotTab = observer(() => {
    const [selectedSnapshotId, setSelectedSnapshotId] = useState<string | null>(
        null,
    );
    const snapshots = LoanApplicationsStore.merchantSnapshots || [];
    const {
        params: { id },
    } = useRouteMatch<{ id: string }>();

    useEffect(() => {
        LoanApplicationsStore.loadCheckPenaltyData(id);

        return () => {
            LoanApplicationsStore.merchantSnapshotsLoader.reset();
        };
    }, [id]);

    const snapshotOptions = useMemo(() => {
        return snapshots.map((snapshot) => {
            const dateValue = snapshot.createdAt;
            const formattedDate = dateValue
                ? DateHelper.formatDate(dateValue)
                : '';

            return {
                value: dateValue || '',
                label: formattedDate,
            };
        });
    }, [snapshots]);

    const selectedSnapshot = useMemo(() => {
        if (!selectedSnapshotId && snapshots.length > 0) {
            const first = snapshots[0];
            if (first.createdAt) {
                setSelectedSnapshotId(first.createdAt);
            }

            return first;
        }

        return snapshots.find(
            (snapshot) => snapshot.createdAt === selectedSnapshotId,
        );
    }, [snapshots, selectedSnapshotId]);

    const hasSnapshots = snapshots.length > 0;

    return (
        <Row gutter={[16, 16]} align="middle">
            {hasSnapshots && (
                <>
                    <Col>
                        {t('LoanApplication.MerchantSnapshot.SnapshotDate')}:
                    </Col>
                    <Col flex={1}>
                        <StyledSelect
                            value={selectedSnapshotId}
                            onChange={setSelectedSnapshotId}
                            options={snapshotOptions}
                        />
                    </Col>
                </>
            )}

            <Col xs={24}>
                {selectedSnapshot && (
                    <>
                        <LoanApplicationMerchantSnapshotGeneralInfo
                            snapshot={selectedSnapshot}
                        />
                        <LoanApplicationMerchantSnapshotBusinessInfo
                            snapshot={selectedSnapshot}
                        />
                        <LoanApplicationMerchantSnapshotSales
                            snapshot={selectedSnapshot}
                        />
                    </>
                )}
            </Col>
        </Row>
    );
});

const StyledSelect = styled<any>(Select)`
    min-width: 100px;
`;
